/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/undefined/ngm-portal-jws/public/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "Sl6L");
/******/ })
/************************************************************************/
/******/ ({

/***/ "8fE/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function debounce(fn) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;

  var cb = fn;
  var timerId = null;

  function debounced() {
    var ctx = this;
    var args = arguments;
    clearTimeout(timerId);
    timerId = setTimeout(function () {
      cb.apply(ctx, args);
    }, delay);
  }
  return debounced;
}

function throttle(fn) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;

  var cb = fn;
  var timerId = null;
  var firstInvoke = true;
  function throttled() {
    var ctx = this;
    var args = arguments;

    if (firstInvoke) {
      cb.apply(ctx, args);
      firstInvoke = false;
      return;
    }

    if (timerId) {
      return;
    }

    timerId = setTimeout(function () {
      clearTimeout(timerId);
      timerId = null;

      cb.apply(ctx, args);
    }, delay);
  }
  return throttled;
}

function isArray(it) {
  return Object.prototype.toString.call(it) === '[object Array]';
}

var AgStat = function () {
  function AgStat(page, options, opts) {
    _classCallCheck(this, AgStat);

    if (!page) {
      console.error('[constructor]初始化时，页面打点基础页面别称不能为空');
      return;
    }
    this.page = page;
    this.basestatinfo = _extends({
      ag_module: page + '_index'
    }, options);
    this.scrollListener = $(window);
    this.ExplorePortalEleMap = {};
    this.initBindElementClick();
    this.initBindElementExplore();
    this.sendPortalAdUrl = '/stat/report/new/';

    this.KEY_WHITELIST = ['ag_module', 'ag_ct', 'action', 'ag_field', 'ag_value', 'ag_extend', 'ag_a1', 'ag_a2', 'ag_a3', 'ag_a4', 'ag_a5', 'ag_a6', 'ag_a7', 'ag_a8', 'ag_a9', 'ag_a10', 'ag_a11', 'ag_a12', 'ag_a13', 'ag_a14', 'zzjs', 'zxbj', 'submit_remark', 'audit_person'];
    this.TYPES = ['expose', 'click', 'quick_down', 'down', 'data'];
    this.pageStartTime = Date.now();
    this.hiddenTime = 0;
    this.hiddenStartTime = 0;
    this.init(opts);
  }

  _createClass(AgStat, [{
    key: 'init',
    value: function init(opts) {
      var _this = this;

      window.GLOBAL_AgStat = this;
      window.addEventListener('load', function () {
        if (opts && opts.CloseStatTime) {
          console.log('[关闭页面统计] heartStat');
          return;
        }
        _this.pageStartTime = Date.now();
        setTimeout(function () {
          var performance = window.performance || window.msPerformance || window.webkitPerformance;
          if (performance) {
            var timing = performance.timing;
            _this.customStatPortal({
              ag_extend: 'perf',
              ag_a1: timing.responseEnd - timing.fetchStart,
              ag_a2: timing.domInteractive - timing.fetchStart,
              ag_a3: timing.domContentLoadedEventEnd - timing.fetchStart,
              ag_a4: timing.loadEventStart - timing.fetchStart,
              ag_a5: timing.domainLookupEnd - timing.domainLookupStart,
              ag_a6: timing.connectEnd - timing.connectStart,
              ag_a7: timing.responseStart - timing.requestStart,
              ag_a8: timing.responseEnd - timing.responseStart,
              ag_a9: timing.domInteractive - timing.responseEnd,
              ag_a10: timing.loadEventStart - timing.domContentLoadedEventEnd }, 'data');
          } else {
            _this.customStatPortal({
              ag_extend: 'noperf'
            }, 'data');
          }
        }, 0);
        var num = 0;
        var heartStat = function heartStat() {
          _this.customStatPortal({
            ag_extend: 'staytime',
            ag_a1: ++num
          }, 'data');
        };
        var timer = setInterval(heartStat, 15000);
        window.addEventListener('visibilitychange', function (e) {
          if (document.visibilityState && document.visibilityState === 'hidden') {
            _this.hiddenStartTime = Date.now();

            clearInterval(timer);
          } else if (document.visibilityState && document.visibilityState === 'visible') {
            if (_this.hiddenStartTime > 0) {
              _this.hiddenTime = Date.now() - _this.hiddenStartTime;

              timer = setInterval(heartStat, 15000);
            }
          }
        });
      }, false);
    }
  }, {
    key: 'handleStat',
    value: function handleStat(stat, type) {
      var reportStat = _extends({
        ag_ct: type
      }, this.basestatinfo);
      if (type === 'expose' || type === 'click') {
        reportStat.action = this.page + '_' + type;
      } else if (type === 'quick_down' || type === 'down') {
        reportStat.action = this.page + '_down';
      } else if (type === 'data') {
        reportStat.action = this.page + '_data';
      }
      if (typeof stat === 'string') {
        var array = stat.split(';');
        array.forEach(function (element) {
          var tempInfo = element.split(':');
          reportStat[tempInfo[0]] = tempInfo[1];
        });
      } else if ((typeof stat === 'undefined' ? 'undefined' : _typeof(stat)) === 'object') {
        reportStat = _extends({}, reportStat, stat);
      }
      return reportStat;
    }
  }, {
    key: 'customStatPortal',
    value: function customStatPortal(stat, type) {
      if (Object.prototype.toString.call(stat) !== '[object Object]') {
        console.error('[customStatPortal]中stat仅支持对象类型');
        return;
      }
      var hasType = this.TYPES.find(function (v) {
        return v === type;
      });
      if (!hasType) {
        console.error('[customStatPortal]中type必须为expose、click、quick_down、down、data中的一种');
        return;
      }
      var statInfo = this.handleStat(stat, type);
      this.StatPortal(statInfo);
    }
  }, {
    key: 'StatPortal',
    value: function StatPortal(statInfo) {
      if (!statInfo.action) {
        console.warn('[SendToPortal]:action不能为空');
        return;
      }

      this.SendToPortal(_extends({}, statInfo, {
        ag_url: window.location.pathname + window.location.search,
        ag_a14: Date.now() - this.pageStartTime - this.hiddenTime }));
    }
  }, {
    key: 'StatPortalV2',
    value: function StatPortalV2(statInfos) {
      var _this2 = this;

      if (this.IsSpider()) return;
      if (typeof $ === 'undefined') {
        console.warn('[StatPortalV2]:缺少"$"依赖,ajax上报门户失败');
        return;
      }

      if (!isArray(statInfos)) {
        console.warn('[StatPortalV2]:statInfos必须是数组');
        return;
      }

      var stats = '';
      statInfos.forEach(function (item) {
        if (!item.action) {
          console.warn('[StatPortalV2]:action不能为空');
          return;
        }
        var temp = '';
        for (var i in item) {
          if (typeof item[i] !== 'undefined') {
            temp += i + ':' + item[i] + '`';
          }
        }
        temp += 'ag_url:' + (window.location.pathname + window.location.search) + '`';
        temp += 'ag_a14:' + (Date.now() - _this2.pageStartTime - _this2.hiddenTime) + '`';
        stats += temp.substring(0, temp.length - 1) + '####';
      });

      var data = {
        logs: stats.substring(0, stats.length - 4)
      };

      window.setTimeout(function () {
        $.ajax({
          type: 'POST',
          url: '/stat/report/list/',
          data: data,
          timeout: 4000,
          success: function success(data) {},
          error: function error(err) {}
        });
      }, 0);
    }
  }, {
    key: 'isElementVisible',
    value: function isElementVisible(element, wrapper) {
      var e = element;
      if (!e || typeof document === 'undefined') {
        return false;
      }

      var wrapperWidth = void 0;
      var wrapperHeight = void 0;
      var wrapperTop = 0;
      var wrapperLeft = 0;
      wrapper = wrapper || window;

      if (wrapper === window) {
        wrapperWidth = window.innerWidth || document.documentElement.clientWidth;
        wrapperHeight = window.innerHeight || document.documentElement.clientHeight;
      } else {
        var wrapperRect = wrapper.getBoundingClientRect();
        wrapperTop = wrapperRect.top;
        wrapperLeft = wrapperRect.left;
        wrapperWidth = wrapperRect.width;
        wrapperHeight = wrapperRect.height;
      }

      var rect = e.getBoundingClientRect();
      var elementTop = rect.top - wrapperTop;
      var elementLeft = rect.left - wrapperLeft;
      var elementWidth = rect.width;
      var elementOffsetHeight = e.offsetHeight;
      var elementOffsetLeft = elementLeft + elementWidth / 2;

      if (rect.width === 0 && rect.height === 0) {
        return false;
      }

      if (elementOffsetLeft < wrapperWidth && elementOffsetLeft >= 0) {
        if (elementTop >= 0) {
          if (elementTop + 8 < wrapperHeight) {
            return true;
          }
        } else if (Math.abs(elementTop) + 8 < elementOffsetHeight) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: 'doExploreV2',
    value: function doExploreV2() {
      var _this3 = this;

      var deletePortalIndex = [];
      var batchUploadStats = [];
      for (var i in this.ExplorePortalEleMap) {
        if (this.isElementVisible($('[ag-expose=\'' + i + '\']')[0])) {
          deletePortalIndex.push(i);
          batchUploadStats.push(this.ExplorePortalEleMap[i].stat);
        }
      }
      if (batchUploadStats.length > 0) {
        this.StatPortalV2(batchUploadStats);
      }
      deletePortalIndex.forEach(function (e) {
        delete _this3.ExplorePortalEleMap[e];
      });
    }
  }, {
    key: 'enforceDoExplore',
    value: function enforceDoExplore(exposeStat) {
      if (this.ExplorePortalEleMap[exposeStat]) {
        this.StatPortal(this.ExplorePortalEleMap[exposeStat].stat);
        delete this.ExplorePortalEleMap[exposeStat];
      }
    }
  }, {
    key: 'initBindElementExplore',
    value: function initBindElementExplore() {
      var _this4 = this;

      window.setTimeout(function () {
        $('[ag-expose]').each(function (index, e) {
          var isXlyxTemplate = $(e).attr('type') === 'template' ? true : false;
          if (isXlyxTemplate) return;
          var exposeStat = $(e).attr('ag-expose');
          var stat = _this4.handleStat(exposeStat, 'expose');
          _this4.ExplorePortalEleMap[exposeStat] = {
            stat: stat
          };
        });
        _this4.doExploreV2();
        _this4.bindScrollEvent();
      }, 1000);
    }
  }, {
    key: 'addRecommendExplorePortalEleMap',
    value: function addRecommendExplorePortalEleMap(ele) {
      var _this5 = this;

      if (ele.length === 0) {
        return;
      }
      var exposeStat = $(ele).attr('ag-expose');
      if (!exposeStat) {
        return;
      }
      setTimeout(function () {
        var stat = _this5.handleStat(exposeStat, 'expose');
        _this5.ExplorePortalEleMap[exposeStat] = {
          stat: stat
        };
      }, 0);
    }
  }, {
    key: 'bindScrollEvent',
    value: function bindScrollEvent() {
      var _this6 = this;

      if (window.location.host.indexOf('www.9game.cn') > -1) {
        this.scrollListener[0].addEventListener('scroll', throttle(function (e) {
          _this6.doExploreV2();
        }), false);
      } else {
        this.scrollListener.on('scroll', throttle(function (e) {
          _this6.doExploreV2();
        }), false);
      }
    }
  }, {
    key: 'initBindElementClick',
    value: function initBindElementClick() {
      this.addCustomClick($('[ag-click],[ag-down],[ag-qdown]'));
    }
  }, {
    key: 'addCustomClick',
    value: function addCustomClick(targets) {
      var _this7 = this;

      window.setTimeout(function () {
        $(targets).each(function (i, ele) {
          $(ele).on('click', debounce(function () {
            var clickTypeStatInfo = $(ele).attr('ag-click');
            var downTypeStatInfo = $(ele).attr('ag-down');
            var qdownTypeStatInfo = $(ele).attr('ag-qdown');
            var type = '';
            var statInfo = '';
            if (clickTypeStatInfo) {
              type = 'click';
              statInfo = clickTypeStatInfo;
            } else if (downTypeStatInfo) {
              type = 'down';
              statInfo = downTypeStatInfo;
            } else if (qdownTypeStatInfo) {
              type = 'quick_down';
              statInfo = qdownTypeStatInfo;
            }
            if (!statInfo) return;
            var stat = _this7.handleStat(statInfo, type);
            _this7.StatPortal(stat);
          }));
        });
      }, 0);
    }
  }, {
    key: 'IsSpider',
    value: function IsSpider() {
      return !!window.navigator.userAgent.toLowerCase().match('spider') || !!window.navigator.userAgent.toLowerCase().match('bot');
    }
  }, {
    key: 'SendToPortal',
    value: function SendToPortal(stat) {
      var _this8 = this;

      if (this.IsSpider()) return;
      if (typeof $ === 'undefined') {
        console.warn('[SendToPortal]:缺少"$"依赖,ajax上报门户失败');
        return;
      }

      window.setTimeout(function () {
        $.ajax({
          type: 'POST',
          url: _this8.sendPortalAdUrl,
          data: stat,
          timeout: 4000,
          success: function success(data) {},
          error: function error(err) {}
        });
      }, 0);
    }
  }, {
    key: 'createPageStat',
    value: function createPageStat(obj, type) {
      var _this9 = this;

      if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
        return;
      }
      obj = _extends({}, this.basestatinfo, obj);
      var stat = '';
      Object.keys(obj).forEach(function (key, idx) {
        if (_this9.KEY_WHITELIST.includes(key)) {
          if (idx == 0) {
            stat += key + ':' + obj[key];
          } else {
            stat += ';' + key + ':' + obj[key];
          }
        }
      });
      if (type === 'expose') {
        return 'ag-expose="' + stat + '"';
      } else if (type === 'click') {
        return 'ag-click="' + stat + '"';
      } else if (type === 'quick_down') {
        return 'ag-qdown="' + stat + '"';
      } else if (type === 'down') {
        return 'ag-down="' + stat + '"';
      }
    }
  }, {
    key: 'scrollDOM',
    set: function set($DOM) {
      this.scrollListener = typeof $DOM === 'string' ? $($DOM) : $DOM;
      this.bindScrollEvent();
    }
  }]);

  return AgStat;
}();

module.exports = AgStat;

/***/ }),

/***/ "Ajji":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sl6L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__("Ajji");
var AgStat = __webpack_require__("8fE/");
var _gameid = $('#_gameid').val();
var _gamename = $('#_gamename').val();
var _pagemodule = $('#_pagemodule').val();
var _hasPkg = $('#_hasPkg').val();

if (_pagemodule && _gameid && _gamename) {
  var ag_stat = new AgStat(_pagemodule, {
    ag_field: 'gameid',
    ag_value: _gameid,
    ag_a7: _gamename,
    ag_a8: _hasPkg
  });
}

var PcGameZoneModule = function () {
  function PcGameZoneModule() {
    _classCallCheck(this, PcGameZoneModule);

    this.GrTanchuan();
    this.createQrcode();
    this.showMore();
  }

  _createClass(PcGameZoneModule, [{
    key: 'GrTanchuan',
    value: function GrTanchuan() {
      if ($('#ng_game_xiaxian').length > 0) {
        $('#ng_game_xiaxian').on('click', function (e) {
          $('.xiaxian-mask').removeClass('hide');
        });
        $('.xiaxian-close').on('click', function (e) {
          $('.xiaxian-mask').addClass('hide');
        });

        var qrTxt = $('#ng_game_xiaxian').data('href');
        var qrcode = window.xMan_qrcode({
          render: 'canvas',
          width: 120,
          height: 120,
          correctLevel: 0,
          text: qrTxt
        });
        $('#xiaxian-qrcode').append(qrcode);
      }
    }
  }, {
    key: 'createQrcode',
    value: function createQrcode() {
      $('.JS_qrcode_game_down').each(function (idx, elem) {
        var gameId = $(elem).data('gameid');
        var ch = $(elem).data('ch');
        var r = $(elem).data('width') || 140;
        var url = $(elem).data('url');
        var downUrl = '';
        if (ch && ch.length > 0) {
          downUrl = 'https://render-se.9game.cn/p/r/66ebe990a7493b10d5223074/index?pageType=game_detail&ch=' + ch + '&gameId=' + gameId + '&pullUpFrom=ugt_game_highspeed_' + gameId + '&opt=download';
          if (parseInt(gameId, 10) === 79532) {
            downUrl = 'https://render-se.9game.cn/p/r/66ebe990a7493b10d5223074/index?pageType=home&ch=' + ch;
          }
        } else {
          downUrl = url;
        }
        var qrcode = window.xMan_qrcode({
          render: 'canvas',
          width: r,
          height: r,
          correctLevel: 0,
          text: downUrl
        });
        $(elem).append(qrcode);
        $(elem).addClass('show');
      });
    }
  }, {
    key: 'showMore',
    value: function showMore() {
      $('.ngame-dws').delegate('.more', 'mouseenter', function () {
        $(this).children('.tips').show();
      });
      $('.ngame-dws').delegate('.more', 'mouseleave', function () {
        $(this).children('.tips').hide();
      });
    }
  }]);

  return PcGameZoneModule;
}();

new PcGameZoneModule();

function replaceUserInfo(data) {
  if (data == null || data.uid == null || data.uid <= 0) {
    return;
  }

  var memberUrl = "https://myspace.9game.cn/";
  var memberCss = "";
  if (data.member != null && data.member.memberType != null && data.member.memberType == 1 && data.member.memberGrade > 0) {
    memberUrl = "https://huiyuan.9game.cn/";
    memberCss = "vip link vip" + data.member.memberGrade;
  }

  var userInfoBlock = $("li#ajaxLogin");
  var userMsgBlock = $("li#ajaxRegister");
  var userInfoHtml = $("li#ajaxUserInfo");
  var userMsgHtml = $("li#ajaxMsg");
  var userLoginSign = $("#login");

  userInfoBlock.attr("class", userInfoHtml.attr("class"));
  userMsgBlock.attr("class", userMsgHtml.attr("class"));
  userLoginSign.attr("value", 1);

  $("img[ajaxName=userLogo]").attr("src", data.logoImgSrc);
  $("a[ajaxName=userName]").attr("class", memberCss);
  $("a[ajaxName=userName]").attr("href", memberUrl);
  $("a[ajaxName=userName]").text(data.nickName);
  $("span[ajaxName=msgNum]").text(data.msg.msgNum);
  $("span[ajaxName=sysMsgNum]").text(data.msg.sysMsgNum);
  $("span[ajaxName=actMsgNum]").text(data.msg.actMsgNum);
  $("span[ajaxName=ghMsgNum]").text(data.msg.ghMsgNum);
  $("span[ajaxName=kaMsgNum]").text(data.msg.kaMsgNum);
  $("span[ajaxName=bbsMsgNum]").text(data.msg.bbsMsgNum);
  $("span[ajaxName=dialogMsgNum]").text(data.msg.dialogMsgNum);
  $("span[ajaxName=imMsgNum]").text(data.msg.imMsgNum);

  userInfoBlock.html(userInfoHtml.html());
  userMsgBlock.html(userMsgHtml.html());
}

window.onload = function () {
  $.ajax({
    url: window.location.origin + "/tpl/pc2/ajaxinfo/ajax_login_info.html",
    type: 'POST',
    timeout: 15e3,
    data: null,
    success: function success(data, state) {
      if (data != null && data.uid != null && data.uid > 0) {
        replaceUserInfo(data);
      }
    },
    dataType: "json"
  });
};

/***/ })

/******/ });


// WEBPACK FOOTER //
// js/pc_gamezone/index.ce98cc75.js